import script from "./DropdownCidadesAtiva.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownCidadesAtiva.vue?vue&type=script&setup=true&lang=ts"

import "./DropdownCidadesAtiva.vue?vue&type=style&index=0&id=e374e376&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e374e376"]])

export default __exports__